import { Component } from 'react';
import { observable, action, makeObservable } from 'mobx';
import { observer } from 'mobx-react';

interface ContextLengthSliderProps {
  contextLength?: string;
  onContextLengthChange?: (value: string) => void;
}

const CONTEXT_OPTIONS_GUEST = ['4k', '8k', '16k', '32k', '48k', '64k', 'auto'];
const CONTEXT_OPTIONS_USER = ['4k', '8k', '16k', '32k', '48k', '64k', '96k', '128k', 'auto'];
const CONTEXT_OPTIONS_ADMIN = ['4k', '8k', '16k', '32k', '48k', '64k', '96k', '128k', '256k', 'auto'];

@observer
export default class ContextLengthSlider extends Component<ContextLengthSliderProps> {
  @observable private _selectedIndex: number; 
  
  private get CONTEXT_OPTIONS(): string[] {
    // Example logic to determine user role; replace with actual implementation
    const userRole = window.user?.role;
    if (userRole === 'admin') {
      return CONTEXT_OPTIONS_ADMIN;
    }
    else if (userRole === 'user') {
      return CONTEXT_OPTIONS_USER;
    }
    return CONTEXT_OPTIONS_GUEST;
  }

  constructor(props: ContextLengthSliderProps) {
    super(props);
    makeObservable(this);
    const initialIndex = this.CONTEXT_OPTIONS.indexOf(props.contextLength || 'auto');
    this._selectedIndex = initialIndex !== -1 ? initialIndex : this.CONTEXT_OPTIONS.indexOf('auto');
  }

  @action
  private _handleSliderChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const index = parseInt(event.target.value, 10);
    this._selectedIndex = index;
    this.props.onContextLengthChange?.(this.CONTEXT_OPTIONS[index]);
  };

  render() {
    const selectedValue = this.CONTEXT_OPTIONS[this._selectedIndex];

    return (
      <div className="context-length-slider">
        <div className="slider-header">
          <label className="slider-label">Context Length</label>
          <span className="slider-value">{selectedValue}</span>
        </div>

        <div className="slider-container">
          <input
            type="range"
            min="0"
            max={this.CONTEXT_OPTIONS.length - 1}
            value={this._selectedIndex}
            onChange={this._handleSliderChange}
            className="slider-track"
          />

          <div className="slider-labels">
            {this.CONTEXT_OPTIONS.map((option, index) => (
              <span
                key={index}
                className="slider-label-text"
                style={{ left: `${(index / (this.CONTEXT_OPTIONS.length - 1)) * 100}%` }}
              >
                {option}
              </span>
            ))}
          </div>
        </div>
      </div>
    );
  }
}